$(function () {
	var $fallbackCards = $('.fallback-honor-card-preview .hc-card');
	var $shadow = $('.hc-content .hc-shadow');
	var $content = $('.hc-content');
	var timeout = null;

	$('#hc-rotate-card-btn').on('click', function () {
		if (timeout) {
			return;
		}
		$content.toggleClass('flipped');
		$shadow.addClass('animate-shadow');
		timeout = setTimeout(function () {
			$shadow.removeClass('animate-shadow');
			timeout = null;
		}, 1000);
	});

	$('#hc-fallback-rotate-card-btn').on('click', function () {
		$fallbackCards.toggleClass('in');
	});
});
